export const cexs = [
  {
    title: "Kucoin",
    img: require("@/assets/logo/kucoin.png"),
    link: "https://www.kucoin.com/trade/HOLD-USDT",
    dataAction: "redirect_kucoin",
  },
  {
    title: "Bitget",
    img: require("@/assets/logo/bitget.png"),
    link: "https://www.bitget.com/spot/HOLDUSDT",
    dataAction: "redirect_bitget",
  },
  {
    title: "Gate.io",
    img: require("@/assets/logo/gate.png"),
    link: "https://www.gate.io/trade/HOLDSTATION_USDT",
    dataAction: "redirect_gate",
  },
  {
    title: "Mexc",
    img: require("@/assets/logo/mexc.png"),
    link: "https://www.mexc.com/exchange/HOLDSTATION_USDT",
    dataAction: "redirect_mexc",
  },
  {
    title: "BingX",
    img: require("@/assets/logo/bingx.png"),
    link: "https://bingx.com/en/spot/HOLDUSDT/",
    dataAction: "redirect_bingx",
  },
];
